import {
  galleryimageorientation
} from '../../utilities/helpers';

import jQuery from 'jquery';

export function visbilityToggle($labelVisibility, $thisgroup) {
  var layervalue = $labelVisibility.data('label-visibility');

  $labelVisibility.click(function () {

    var $this = $(this);
    $thisgroup.find($('.revitlayers__layer-' + layervalue + '')).toggleClass('visibility-off');
    $this.closest($('.revitlayers__label-' + layervalue + '')).toggleClass('label-off');

  }); //click

}

export function layersToggle($layersVisibility, $thisgroup) {

  $layersVisibility.click(function () {

    var $span = $(this).find('span');
    if ($span.text() == "Show Layers") {
      $span.text('Hide Layers');
    } else {
      $span.text('Show Layers');
    }

    $thisgroup.toggleClass('--labels-visibility-off');

  }); //click

}

export function labelToggle($labeldescription, $thisgroup) {

  var layervalue = $labeldescription.closest('.revitlayers__label').data('label-number');
  $labeldescription.click(function () { // $thiss  = .label

    var $handle = $('.revitlayers__handle-' + layervalue + '');

    $thisgroup.find($(".revitlayers__layer")).removeClass('--is-active'); // we don't want to remove the class untill another layer is selected
    $thisgroup.find($(".revitlayers__label-" + layervalue + '')).addClass('--is-active');
    $handle.closest(".revitlayers__layer").addClass('--is-active', 'tease-drag'); //review tease drag

  }); //click


}

$.fn.deploiRevitlayers = function (options) {

  var settings = $.extend({
    marginY: 0,
    marginX: 0,
    setX: 0,
    setY: 0,
    direction: "vertical"

  }, options);
  return $(this).each(function () {

    // Initialization
    ////////////////////////////////

    var $this = $(this), //revitlayers__layer
      thisGroupId = $this.closest('.revitlayers__container').attr('data-container-id'),
      layernumber = $this.data('layernumber'),
      $viewArea = $this.find('.revitlayers__view-area-' + layernumber + ''),
      $handle = $this.find('.revitlayers__handle-' + layernumber + ''),
      height = $this.closest('.revitlayers__container').find('.revitlayers__layer-bg').innerHeight(), // allows for that padding below
      width = $this.closest('.revitlayers__container').find('.revitlayers__layer-bg').innerWidth(),
      $bgitem = $this.closest('.revitlayers__container').find('.revitlayers__layer-bg');

    // assign classes on background item - which defines the height of layers;hndles etc
    // galleryimageorientation($thisitem, thisimagewidth, thisimageheight) 
    // $bgitem.css("background", "#ff00002e");
    // console.log("revit layers container height", height);
    // console.log("revit layers container width", width);

   var pos_x = null,
      pos_y = null,
      startX = null,
      startY = null,
      min_left = settings.marginX,
      max_left = width - settings.marginX,
      min_top = settings.marginY,
      max_top = height - settings.marginY,
      setX = settings.setX,
      setY = settings.setY,
      viewAreaHeight = height,
      SetYPercent = ((setY / viewAreaHeight) * 100);


    // console.log(" pos_x",  pos_x);
    // console.log("max_top on Initialization", max_top);
    // console.log("heigh on Initialization", height);

    $viewArea.height(viewAreaHeight);
    galleryimageorientation($bgitem, width, height);

    $this.css('background-image', 'url(' + $this.data('passive') + ')');
    $viewArea.css('background-image', 'url(' + $this.data('active') + ')');

    if (setY < min_top) { // y less then 0
      setY = min_top;
    }
    if (SetYPercent < min_top) { // SetYPercent less then 0
      SetYPercent = min_top;
    }

    // Direction
    //////////////////////////////////

    /*  if (settings.direction === "horizontal") {
        // delete this deirection thing
        // $viewArea.width(setX);
        //$viewArea.css('border-right', '1px dashed #FFF');
      } else 
      
      */
    if (settings.direction === "vertical") {

      // $this.height($viewArea.height());
      $viewArea.height(setY);
      $handle.css('top', setY);
      $handle.attr("data-top-percentage", SetYPercent);
      //		$viewArea.css('border-bottom', '1px dashed #FFF');
      $handle.addClass('vertical');
    }

    // move this into seperate function
    // console.log("END - $.fn.deploiRevitlayers");

    $(window).resize(function () {
      // console.log("window resize", $this);
      resizeLayers($this);
    });

    $handle.on('mousedown', function (event) { // the function runs when handle is mouseclicked
      // review this for touch devices aswell

      $('body').addClass("revitlayers-active");
      // console.log($handle);
      // console.log(layernumber);

      // Remove the --is-active class once another handle has selected
      $("div[data-container-id=" + thisGroupId + "]").find(".revitlayers__layer").removeClass('--is-active');
      // add active class to current
      $("div[data-container-id=" + thisGroupId + "]").find(".revitlayers__layer-" + layernumber + '').addClass('--is-active');
      // console.log("layernumber ", layernumber, "should be active");
      //remove  dragging capabvilites?
      $("div[data-container-id=" + thisGroupId + "]").find('.revitlayers__layer').removeClass('initiate-drag'); // this needs reviewing - inline with flickiuyt slider
      // remove --is-active label:
      $("div[data-container-id=" + thisGroupId + "]").find(".revitlayers__label").removeClass('--is-active');
      // find the associated label and add --is-active class:
      $("div[data-container-id=" + thisGroupId + "]").find(".revitlayers__label-" + layernumber + '').addClass('--is-active');
      //  add this class to other layers to reduce in opacity - ensuring we can always see the underlying ones
      $("div[data-container-id=" + thisGroupId + "]").find('.revitlayers__layer:not(.--is-active)').addClass('no-activity');
      //  event.preventDefault();
      // apply the --is-activel comparison group wich has been selected
      $handle.closest(".revitlayers__layer").addClass('--is-active');

      $handle.addClass('draggable');
      // pos_x = parseInt($handle.css('left'));
      // startX = event.pageX;
      pos_y = parseInt($handle.css('top'));
      startY = event.pageY;

      // console.log(" pos_y ", pos_y);
      // console.log(" startY ", startY);

    }); // mouse down

    //end  move this into seperate function

    // move this into seperate function

    $(document).on('mouseup', function (event) { // should this be document or actually the hande?
      $('body').removeClass("revitlayers-active");

      $handle.removeClass('draggable');
      $("div[data-container-id=" + thisGroupId + "]").find('.revitlayers__layer').removeClass('no-activity'); //  remove this class no longer any activity

    }); //mouse up

    // console.log(" $this = bind mousemove", $this);
    $this.bind('mousemove', dragger);

    function dragger(e) {

      // Ineed to update varioables in here
      // console.log('dragger(e)', e);
      // console.log("viewAreaHeight inside dragger", viewAreaHeight);
      // console.log("e.pageX", e.pageY);
      // console.log("startX", startY);

      var left = pos_x + (e.pageX - startX);

      if (left < min_left) left = min_left;
      else if (left > max_left) left = max_left;

      //don't allow handle to change drag left/right directnion
      // $('.revitlayers__handle-' + layernumber + '.draggable').css('left', left); // we don't really use this. (CSS overrides the position)
      //	console.log('left dragging' + left)

      var top = pos_y + (e.pageY - startY);

      if (top < min_top) top = min_top;
      else if (top > max_top) top = max_top;
      if ($('.revitlayers__handle-' + layernumber + '.draggable').length) {
        changeWidth(left, top);
      }

      var SetYPercent = ((top / viewAreaHeight) * 100);
      // var SetYPercent = ((setY/viewAreaHeight) *100);

      $('.revitlayers__handle-' + layernumber + '.draggable').css('top', top);
      $('.revitlayers__handle-' + layernumber + '.draggable').attr("data-top-percentage", SetYPercent);
      //	console.log('.handle-'+layernumber+ 'top dragging: ' + top)

    }
    //end  move this into seperate function


    function changeWidth(w, h) {

      // console.log("changeWidth(w, h)", "w", w, "h", h)

      if (settings.direction === "horizontal") {
        $viewArea.width(w);
      } else if (settings.direction === "vertical") {
        $viewArea.height(h);
      }

    } // function change width

    //https://stackoverflow.com/questions/5186441/javascript-drag-and-drop-for-touch-devices
    // also read rRE if issues with scrolling - an
    // add a class so that we people interacting with the moving of items the page is fixed


    function resizeLayers($this) {

      var LayerAreaHeight = $this.closest('.revitlayers__container').find('.revitlayers__layer-bg').height(),
        $viewArea = $this.find('.revitlayers__view-area'),
        $revitHandle = $this.find('.revitlayers__handle'),
        YPercent = $revitHandle.attr("data-top-percentage"),
        SetYPosition = (LayerAreaHeight * (YPercent / 100)),
        viewAreaHeight = (LayerAreaHeight * (YPercent / 100));

      //update exisisting valueues
      max_top = (viewAreaHeight - settings.marginY);
      // console.log("max_top after resizes", max_top);
      $viewArea.height(viewAreaHeight); // set height based on the relatively sccaled: .revitlayers__layer

      // changed the top position of teh handles base don teh current positi9on and new hiehgt
      $revitHandle.css("top", SetYPosition);


      // event.
    }


    //https://stackoverflow.com/questions/55955171/preventing-unable-to-preventdefault-inside-passive-event-listener-error-within 
    // move this out f ther? into some thing global? - there might be other instacnes where its needed
    // fuck knows how this works?

    const eventListenerOptionsSupported = () => {
      let supported = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          get() {
            supported = true;
          }
        });

        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
      } catch (e) {}

      return supported;
    }

    const defaultOptions = {
      passive: false,
      capture: false
    };
    const supportedPassiveTypes = [
      'scroll', 'wheel',
      'touchstart', 'touchmove', 'touchenter', 'touchend', 'touchleave',
      'mouseout', 'mouseleave', 'mouseup', 'mousedown', 'mousemove', 'mouseenter', 'mousewheel', 'mouseover'
    ];
    const getDefaultPassiveOption = (passive, eventName) => {
      if (passive !== undefined) return passive;

      return supportedPassiveTypes.indexOf(eventName) === -1 ? false : defaultOptions.passive;
    };

    const getWritableOptions = (options) => {
      const passiveDescriptor = Object.getOwnPropertyDescriptor(options, 'passive');

      return passiveDescriptor && passiveDescriptor.writable !== true && passiveDescriptor.set === undefined ?
        Object.assign({}, options) :
        options;
    };

    const overwriteAddEvent = (superMethod) => {
      EventTarget.prototype.addEventListener = function (type, listener, options) {
        const usesListenerOptions = typeof options === 'object' && options !== null;
        const useCapture = usesListenerOptions ? options.capture : options;

        options = usesListenerOptions ? getWritableOptions(options) : {};
        options.passive = getDefaultPassiveOption(options.passive, type);
        options.capture = useCapture === undefined ? defaultOptions.capture : useCapture;

        superMethod.call(this, type, listener, options);
      };

      EventTarget.prototype.addEventListener._original = superMethod;
    };

    const supportsPassive = eventListenerOptionsSupported();

    if (supportsPassive) {
      const addEvent = EventTarget.prototype.addEventListener;
      overwriteAddEvent(addEvent);
    }
    /* wonders indeed

        */


    function touchHandler(event) {
      var touch = event.changedTouches[0];

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent({
          touchstart: "mousedown",
          touchmove: "mousemove",
          touchend: "mouseup"
        } [event.type], true, true, window, 1,
        touch.screenX, touch.screenY,
        touch.clientX, touch.clientY, false,
        false, false, false, 0, null);

      touch.target.dispatchEvent(simulatedEvent);

      var $target = $(event.target);
      if ($target.hasClass('draggable')) {
        event.preventDefault();
      }

    } // function touchhandler
    // revioew the location of this maybe just have this outside as a webshite wide function
    function init() {
      document.addEventListener("touchstart", touchHandler, true);
      // document.addEventListener("touchmove", touchHandler, true);
      document.addEventListener("touchend", touchHandler, true);
      document.addEventListener("touchcancel", touchHandler, true);
      // try setting this to false?
      document.addEventListener("touchmove", touchHandler, false);
      //https://stackoverflow.com/questions/55548261/unable-to-preventdefault-inside-passive-event-listener-due-to-target-being-treat

    } // function init

    init();

  });

}

 



export function revitLayersItem($revitLayersContainer) {
  // console.log("$revitLayersContainer",$revitLayersContainer);

  $revitLayersContainer.each(function () {


    // console.log("$revitLayersContainer",$(this));

    var togglelayers = false,
      // var $thisgroup = $(this).find(".comparison");
      $thisgroup = $(this), //
      // thisheight = $thisgroup.height(), // ckhanged thjis to the bg image item for height caculation
      thisheight = $thisgroup.find('.revitlayers__layer-bg').height(),
      // thisGroupId = $thisgroup.attr('data-container-id'), // instead of traversing one up the id is assigned here
      total = $thisgroup.find($('.revitlayers__layer')).length;

    // console.log("Before assiging thisheight =", thisheight);
    // console.log('total .revitlayers__layer' + total);

    // each compirson layer group
    $thisgroup.find($('.revitlayers__layer')).each(function (index) {

      // console.log("hello find comparioson")

      // if (index === (total - 1)) {
      if (index === (0)) {

        // console.log('if (index ===  1)')
        // console.log('if (index === total - 1)')

        var $this = $(this);
        $this.deploiRevitlayers({
          // groupId: comparisongroupid,
          //     marginY : 20 ,
          //     marginX : 400 ,
          // setY  : 200,
          setY: (thisheight * 0.5), // initial measuermenbt
          //     setX  : 235 ,
          direction: "vertical"
        });
        //  console.log('first layer - --is-active one?layer -'+ layervalue);
        // console.log('groupId: comparisongroupid', comparisongroupid);
        // $this.css("background","pink");
        $this.addClass('initiate-drag'); // so the first handle is obvious (should only be applied once)
        // $this.css("background","yellow");
        // console.log('initiate-drag');
        // console.log('ylayervalue = layer number' + layervalue);

      } else { // console.log('not first')

        // we need to flip the order - so number two at the top
        // console.log('NOT  if (index === total - 1)')

        var $this = $(this);
        var layervalue = $(this).data('layernumber');
        var yvalue = layervalue * 20; // revie this its not based on teh relative lineheight measuermetns atm

        // console.log("thisheight " + thisheight + '');
        // console.log('yvalue' + yvalue);
        // console.log('ylayervalue = layer number' + layervalue);
        // console.log('setY:' + ((thisheight * 1) - yvalue) + '');


        $this.deploiRevitlayers({
          // groupId: comparisongroupid,
          //     marginY : 20 ,
          //     marginX : 400 , 
          // initial measuermenb:
          setY: ((thisheight + yvalue) - (total * 20) - 20), // revie this its not based on teh relative lineheight measuermetns atm
          //     setX  : 235 ,
          direction: "vertical"
        });
        // set lineheight classes initially ?
        // so total (total-current index) - equals ofset from bottom
        // console.log(' setY' + setY);
        // $this.css("background","pink");

        // $this.find('.revitlayers__handle').addClass('--baseline-bottom--' + (total - layervalue) + '');


        $this.removeClass('--is-active'); // so only the first layer is '--is-active'
        $thisgroup.find($('.revitlayers__labels .revitlayers__label-' + layervalue + '')).removeClass('--is-active'); // so only the first layer is '--is-active'

      } //  if (index === total - 1)

    }); // each revitlayers__layer

    //each lavel

    $thisgroup.find($('.label__description-item')).each(function () {
      // console.log('$thisgroup.find($(".label-description")).each(function () ');
      // console.log('$thisgroup',$thisgroup);

      var $labeldescription = $(this);

      labelToggle($labeldescription, $thisgroup);

    }); // each comparison

    $thisgroup.find($('.label__visibility')).each(function () {
      // console.log('$thisgroup.find($(".label-visibility")).each(function () ');

      // console.log('$thisgroup',$thisgroup);

      var $labelVisibility = $(this);

      visbilityToggle($labelVisibility, $thisgroup);

    }); // each  

    $thisgroup.find($('.revitlayers__visibilty')).each(function () {
      var $layersVisibility = $(this);

      layersToggle($layersVisibility, $thisgroup);


    }); // each  


  }); // each 

}; //function  